import CompensationFeeCards from "./CompensationFeeCards";

export default CompensationFeeCards;
export type { CompensationFeeCardsAdapterProps, CompensationFeeCardProps } from "./CompensationFeeCards.d";
